import { render, staticRenderFns } from "./Shapes.vue?vue&type=template&id=63f428e6&scoped=true&"
import script from "./Shapes.vue?vue&type=script&lang=js&"
export * from "./Shapes.vue?vue&type=script&lang=js&"
import style0 from "./Shapes.vue?vue&type=style&index=0&id=63f428e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f428e6",
  null
  
)

export default component.exports